import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(value: number) {
  const num = Number(value) || 0;
  return `ETB ${num.toLocaleString("en-US", {
    minimumFractionDigits: num % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2
  })}`;
}

export function compactNumber(value: number) {
  return new Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 1
  }).format(value);
}

export function getDiscount(price: number, mrp: number) {
  return Math.round(((mrp - price) / mrp) * 100);
}

export function absoluteUrl(path = "") {
  const base =
    (import.meta.env.VITE_APP_URL as string | undefined) ||
    (typeof window !== "undefined" ? window.location.origin : "http://localhost:5173");
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}
